Ext.define('SA.view.RemoveBuildingBlocks', {
    alias: 'widget.remove-building-blocks',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-remove-building-blocks',

    items: [
        {
            xtype: 'component',
            cls: 'sa-remove-building-blocks-header',
            html: 'Remove Locations, Data, or Businesses'
        }, {
            xtype: 'component',
            cls: 'sa-remove-building-blocks-section-btn-wrapper',

            html: [
                '<a data-section="locations" class="sa-remove-building-blocks-section-btn sa-remove-building-blocks-section-btn-selected">',
                    '<svg aria-hidden="true"><use href="#sa-icon-locations"></use></svg>',
                    'Locations',
                '</a>',
                '<a data-section="attributes" class="sa-remove-building-blocks-section-btn">',
                    '<svg aria-hidden="true"><use href="#sa-icon-data"></use></svg>',
                    'Data',
                '</a>',
                '<a data-section="businessSearches" class="sa-remove-building-blocks-section-btn">',
                    '<svg aria-hidden="true"><use href="#sa-icon-businesses"></use></svg>',
                    'Businesses',
                '</a>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-remove-building-blocks-list',
            itemId: 'locationList',

            tpl: [
                '<tpl if="!length">',
                    '<span class="sa-remove-building-blocks-list-empty">',
                        'There are no locations currently associated with this project',
                    '</span>',
                '</tpl>',
                '<tpl for=".">',
                    '<div data-id="{id}" class="sa-remove-building-blocks-item">',
                        '<tpl if="isCustom">',
                            '<span class="sa-remove-building-blocks-item-icon-wrap">',
                                '<svg class="sa-remove-building-blocks-item-icon">',
                                    '<tpl if="type === \'combination\'">',
                                        '<use href="#sa-icon-combination-location"></use>',
                                    '<tpl elseif="type === \'radius\'">',
                                        '<use href="#sa-icon-radius-location"></use>',
                                    '</tpl>',
                                '</svg>',
                            '</span>',
                        '</tpl>',
                        '<div class="sa-remove-building-blocks-item-name">{name}<tpl if="unit"> ({unit})</tpl></div>',
                            '<a class="sa-remove-building-blocks-item-button">',
                                '<svg><use href="#sa-icon-close"></use></svg>',
                            '</a>',
                    '</div>',
                '</tpl>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-remove-building-blocks-list',
            hidden: true,
            itemId: 'attributeList',

            tpl: [
                '<tpl if="!length">',
                    '<span class="sa-remove-building-blocks-list-empty">',
                        'There are no data variables currently associated with this project',
                    '</span>',
                '</tpl>',
                '<tpl for=".">',
                    '<div data-id="{attribute}" class="sa-remove-building-blocks-item">',
                        '<div class="sa-remove-building-blocks-item-name">{.:badgedAttributeRenderer}</div>',
                        '<a class="sa-remove-building-blocks-item-button">',
                            '<svg><use href="#sa-icon-close"></use></svg>',
                        '</a>',
                    '</div>',
                '</tpl>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-remove-building-blocks-list',
            hidden: true,
            itemId: 'businessSearchList',

            tpl: [
                '<tpl if="!length">',
                    '<span class="sa-remove-building-blocks-list-empty">',
                        'There are no business searches currently associated with this project',
                    '</span>',
                '</tpl>',
                '<tpl for=".">',
                    '<div data-id="{id}" class="sa-remove-building-blocks-item">',
                        '<div class="sa-remove-building-blocks-item-name">{name:htmlEncode}</div>',
                        '<a aria-label="remove" class="sa-remove-building-blocks-item-button" role="button">',
                            '<svg aria-hidden="true"><use href="#sa-icon-close"></use></svg>',
                        '</a>',
                    '</div>',
                '</tpl>'
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.locationList = this.down('#locationList');
        this.attributeList = this.down('#attributeList');
        this.businessSearchList = this.down('#businessSearchList');
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClickSectionButton, this, {delegate: '.sa-remove-building-blocks-section-btn'});
        this.el.on('click', this.onClickItemButton, this, {delegate: '.sa-remove-building-blocks-item-button'});
    },

    onClickItemButton(ev, target) {
        var isLocation = this.locationList.el.contains(target),
            isAttribute = this.attributeList.el.contains(target),
            id = ev.getTarget('[data-id]').getAttribute('data-id');

        if (isLocation) {
            this.fireEvent('click:location', {id});
        }
        else if (isAttribute) {
            this.fireEvent('click:attribute', {id});
        }
        else {
            this.fireEvent('click:businessSearch', {id: Number(id)});
        }
    },

    onClickSectionButton(ev, target) {
        var section = target.getAttribute('data-section'),
            buttons = Array.from(this.el.dom.querySelectorAll('.sa-remove-building-blocks-section-btn'));

        buttons.forEach(button => {
            button.classList.toggle('sa-remove-building-blocks-section-btn-selected', section === button.dataset.section);
        });

        this.locationList.setVisible(section === 'locations');
        this.attributeList.setVisible(section === 'attributes');
        this.businessSearchList.setVisible(section === 'businessSearches');
    },

    setData({locations, attributes, businessSearches}) {
        this.attributeList.update(attributes);
        this.businessSearchList.update(businessSearches);

        this.locationList.update(locations.map(location => {
            var type = location.type,
                isCustom = ['radius', 'combination'].includes(type),
                name = Ext.util.Format.locationRenderer(location),
                id = SA.data.LocationsCache.toLocationSeries(location),
                unit = !isCustom && SA.data.GeographicUnits.get(location.geographicUnit).singularName;

            return {id, isCustom, type, name, unit};
        }));
    }
});
